module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/meditating@2x_1b26d9.jpg";